define("shared/modifiers/focus-on-destruct", ["exports", "@ember/destroyable", "@ember/runloop", "@ember/service", "ember-modifier", "later/services/errors"], function (_exports, _destroyable, _runloop, _service, _emberModifier, _errors) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@ember/destroyable",0,"@ember/runloop",0,"@ember/service",0,"ember-modifier",0,"later/services/errors"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  function setFocus(instance) {
    /** Note: The element should be focused during the 'next' run loop, as typically
    the functionality causing the modified element to destruct will also trigger
    a rerender of the parent component */
    const element = instance.focusElement;

    try {
      (0, _runloop.next)(() => element?.focus());
    } catch (error) {
      instance.errors.log(new Error(`FocusOnDestruct error: ${error}`), {}, _errors.ErrorSeverity.Debug);
    }
  }
  /**
   * FocusOnDestruct will focus an element when the modified element is destructed. If an element ID is provided,
   * that element will be focused. If no element ID is provided, the last focused element (document.activeElement) before
   * the modified element was inserted will be focused.
   *
   * Example usage:
   * @example
   * <div ... {{focus-on-destruct "focusId"}}>
   *
   * Example usage with SharedModal:
   * Shared::Modal: <div ... {{focus-on-destruct @focusOnDestructId}}>
   * Shared::Modal Parent: <Shared::Modal @focusOnDestructId="elementId" as |modal|>
   */


  let FocusOnDestructModifier = (_class = class FocusOnDestructModifier extends _emberModifier.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "errors", _descriptor, this);

      _defineProperty(this, "focusElement", null);

      (0, _destroyable.registerDestructor)(this, setFocus);
    }

    modify(_element, _ref) {
      let [focusElementId] = _ref;
      const focusElementOverride = focusElementId && document.getElementById(focusElementId);
      /** document.activeElement returns an Element as opposed to an HTMLElement. In the event the
       * document.activeElement is an XML element instead of an HTML element, we will ignore this
       * functionality by setting the activeElement to null */

      const activeElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      this.focusElement = focusElementOverride ? focusElementOverride : activeElement;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = FocusOnDestructModifier;
});